/*
 * @Date: 2024-07-15 09:20:09
 * @LastEditTime: 2024-07-18 15:16:16
 * @Description: router
 * @FilePath: /ql-official/src/router/index.ts
 */
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/index.vue"),
  },
  {
    path: "/pc/list",
    name: "pcList",
    component: () => import("@/views/pc/list.vue"),
  },
  {
    path: "/pc/article",
    name: "pcArticle",
    component: () => import("@/views/pc/article.vue"),
  },
  {
    path: "/pc/search",
    name: "pcSearch",
    component: () => import("@/views/pc/search.vue"),
  },
  {
    path: "/mobile/submenu",
    name: "mobileSubmenu",
    component: () => import("@/views/mobile/submenu.vue"),
  },
  {
    path: "/mobile/list",
    name: "mobileList",
    component: () => import("@/views/mobile/list.vue"),
  },
  {
    path: "/mobile/article",
    name: "mobileArticle",
    component: () => import("@/views/mobile/article.vue"),
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("@/views/not-found.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
